export function WindowFactory(): any {
    return window;
}
